<template>
    <div class="modal fade text-left mx-auto" :id="videoData.id" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel334" aria-hidden="true" v-if="videoData">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary" id="myModalLabel334">
                        <slot name="video_title"></slot>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-sm-5 mx-50 pb-4 mx-auto" style="width: 100%; height: 100%; position: relative;">                    
                    <div v-if="videoData.type == 'youtube'">
                        <iframe 
                            width="100%" 
                            height="400" 
                            :src="videoData.source" 
                            title="YouTube video player" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            allowfullscreen
                        >
                        </iframe>
                    </div>
                    <div v-else-if="videoData.type == 'mp4'">
                        <video class="videos" playsinline controls data-plyr-config='{ "title": "Creditfixrr Business Company Settings Tutorial" }'>
                            <source :src="videoData.source" type="video/mp4" />
                        </video>
                    </div>
                    <slot name="video" v-else></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'

export default{
    components:{
    },
    props:{
        videoData:{
            type: [Array, Object]
        },
    },
    setup() {
        return{

        }
    }
}
</script>